import { render, staticRenderFns } from "./ManageTabDataPlan.vue?vue&type=template&id=45937dd0&"
import script from "./ManageTabDataPlan.vue?vue&type=script&lang=js&"
export * from "./ManageTabDataPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports